const Legemuster = {
    "3er-Legung": {
        cards: 3,
        description: "Dies ist eine klassische 3-Karten-Legung. Die erste Karte steht für die Vergangenheit, die Zweite für die Gegenwart und die Dritte symbolisiert die Zukunft.",
    },
    "9er-Legung (+ 1 Extrakarte)": {
        cards: 10,
        description: "Dies ist eine detaillierte 9-Karten-Legung, die eine tiefere Einsicht in die Situation bietet. Die erste Karte, die gezogen wird, stellt die Hauptkarte dar und repräsentiert die Gegenwart und die Situation des Fragenden. Danach werden 3 Karten für die Vergangenheit gewählt, anschließend noch 2 Karten ergänzend zur Gegenwart und 3 Karten für die Zukunft. Am Ende noch eine Karte, die die gesamte Legung repräsentiert – die 'Overall Energy' –, die das Thema der Legung bestimmt und einzeln zu betrachten ist.",
    },
    "Jahreslegung (1 pro Monat + 1 Extrakarte)": {
        cards: 13,
        description: "Diese Legung gibt eine Vorschau auf das kommende Jahr. Für jeden Monat wird eine Karte gezogen, die die Hauptthemen und Herausforderungen des Monats darstellt. Die zusätzliche Extrakarte gibt eine übergeordnete Energie, das Hauptthema oder die Lektion für das gesamte Jahr an.",
    },
    "Liebesorakel": {
        cards: 4,
        description: "Eine einfache Legung, die Einblicke in eine romantische Beziehung gibt. Die erste Karte representiert die aktuelle Situation oder Frage in der Beziehung. An zweiter Position kommen die inneren Beweggründe und Motive des Fragestellers, vielleicht auch die die nicht ganz bewusst sind. Die dritte Karte steht für die Gefühle des Partners und wie diese Person zu der Situation (Karte 1) steht. Die letzte Karte kann für einen Ratschlag oder die zukünftige Entwicklung der Beziehung stehen.",
    },
    "Beziehungslegung (klein)": {
        cards: 4,
        description: "Diese Legung gibt einen schnellen Überblick über eine zwischenmenschliche Beziehung. Sie kann für romantische, freundschaftliche oder familiäre Beziehungen genutzt werden. Die Karten zeigen in der Reihenfolge das aktuelle Problem, die Perspektive des Fragenden, die des Gegenübers und dann eine mögliche Lösung.",
    },
    "Beziehungslegung (groß)": {
        cards: 16,
        description: "Eine ausführliche Legung zur Analyse einer Beziehung. Diese Legung eignet sich für tiefgehende Beziehungsanalysen. Sie betrachtet beide Partner, ihre Vergangenheit, Gegenwart, Zukunft, Herausforderungen und Potenziale",
    },
    "Wochenlegung": {
        cards: 10,
        description: "Diese Legung gibt eine Vorschau auf die kommende Woche. Sie zeigt aktuelle Themen, Herausforderungen und Chancen für die nächsten Tage an.",
    },
    "Monatslegung": {
        cards: 10,
        description: "Eine detaillierte Legung, die einen Monat im Voraus betrachtet. Sie gibt Aufschluss über die wichtigsten Ereignisse, Herausforderungen und Chancen für den kommenden Monat.",
    },
    "Entscheidung (2 Wege)": {
        cards: 7,
        description: "Hilft bei einer Entscheidungsfindung zwischen zwei Optionen. Drei Karten zeigen die möglichen Konsequenzen des ersten Weges, drei Karten zeigen die des zweiten Weges, und eine abschließende Karte gibt einen Rat oder zeigt die Gesamtenergie der Situation.",
    },
    "Entscheidung (3 Wege)": {
        cards: 10,
        description: "Hilft bei einer komplexeren Entscheidungsfindung zwischen drei Optionen. Drei Karten für jeden Weg plus eine abschließende Karte, die die Situation zusammenfasst oder einen allgemeinen Rat gibt.",
    },
    "Entscheidung (4 Wege)": {
        cards: 13,
        description: "Eine sehr umfassende Entscheidungslegung für vier mögliche Wege. Jede Option erhält drei Karten, und eine zusätzliche Karte zeigt die übergeordnete Energie oder eine Empfehlung an.",
    },
    "Ja/Nein": {
        cards: 1,
        description: "Eine einzelne Karte, die ein Ja oder Nein als Ergebnis repräsentiert. Zusätzlich gibt sie Kontext und eine Erklärung, warum sie als Ja oder Nein interpretiert wurde.",
    },
    "Argumente: Soll ich es tun?": {
        cards: 3,
        description: "Diese Legung hilft, Argumente für und gegen eine Entscheidung abzuwägen. Die erste Karte zeigt einen positiven Aspekt, die zweite einen negativen Aspekt, und die dritte gibt eine abschließende Empfehlung.",
    },
    "Was passiert als nächstes?": {
        cards: 5,
        description: "Gibt Hinweise darauf, was als nächstes in einer bestimmten Situation geschehen könnte. Die Karten zeigen die aktuelle Lage, mögliche Einflüsse und Entwicklungen.",
    },
    "Das Keltische Kreuz (Allgemein)": {
        cards: 10,
        description: "Eine der bekanntesten Tarot-Legungen für eine umfassende Analyse einer Situation. Die Karten zeigen aktuelle Herausforderungen, verborgene Einflüsse, Zukunftsaussichten und Ratschläge.",
    },
    "Das Kreuz (Ratschlag aktuelle Situation)": {
        cards: 5,
        description: "Eine kompakte Legung für schnelle Antworten auf eine aktuelle Situation. Die Karten stehen für das Problem, die verborgenen Einflüsse, mögliche Herausforderungen, einen Ratschlag und das wahrscheinliche Ergebnis.",
    },
    "Was soll ich machen? (Kurzfristig)": {
        cards: 5,
        description: "Diese Legung bietet kurzfristige Ratschläge für eine aktuelle Frage oder Situation. Sie zeigt das Hauptproblem, Hindernisse, Möglichkeiten, einen Ratschlag und die wahrscheinliche Entwicklung.",
    },
    "Ziel erreichen": {
        cards: 7,
        description: "Eine Legung, die zeigt, wie man ein bestimmtes Ziel erreichen kann. Die Karten repräsentieren aktuelle Stärken, Herausforderungen, notwendige Schritte und das wahrscheinliche Ergebnis.",
    },
};

export default Legemuster;
